<article class="chatroom">
  <section class="chatroom-list-wrapper">
    <app-search-bar class="searchbar" (valueChange)="onSearchValueChange($event)"></app-search-bar>
    <ul *ngIf="chatrooms" class="chatroom-list">
      <li
        *ngFor="let room of chatrooms"
        class="chatroom-list-item"
        [ngClass]="{
          active: room.id === selectedChatroomId,
          unread: unreadChatrooms.has(room.id),
          'no-messages': room.messages.edges.length === 0
        }"
        (click)="selectChatroom(room.id)">
        <header class="chatroom-list-item-header">
          <p class="chatroom-members">
            <span class="chatroom-member" *ngFor="let member of room.members">{{ member.firstName }} {{ member.lastName }}</span>
          </p>
          <p class="chatroom-last-changed" *ngIf="room.messages.edges.length > 0">
            {{ room.messages.edges.reverse()[0].node.created | dateToString : "chatroom" }}
          </p>
        </header>
        <p class="chatroom-first-line" *ngIf="room.messages.edges.length > 0">{{ room.messages.edges.reverse()[0].node.message }}</p>
      </li>
    </ul>
  </section>
  <app-chatroom [chatroomId]="selectedChatroomId" [currentUserId]="currentUserId" (seen)="onChatroomSeen($event)"></app-chatroom>
</article>
